import React, { useState, useEffect } from "react";
import { Label } from "reactstrap";
import Select from "react-select";
import { Trans } from 'react-i18next';
import { post } from "../helpers/api_helper";
import { SHIPMENT_TYPES_SEARCH } from "helpers/api_endpoints";

// Multi-select of shipment types; value/onChange work with an array of ids
const ShipmentTypesSelect = ({ value = [], onChange, InputWidth = '4' }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        post(SHIPMENT_TYPES_SEARCH, {})
            .then(response => {
                setOptions((response.data || []).map(el => ({ value: el.id, label: el.name })));
            })
            .catch(error => console.log(error));
    }, []);

    return (
        <div className={`form-group col-md-${InputWidth} mt-2`}>
            <Label className="form-label"><Trans>Shipment Types</Trans></Label>
            <Select
                name="shipmentTypeIds"
                value={options.filter(option => value.includes(option.value))}
                options={options}
                isMulti
                className="form-control select2"
                onChange={(selected) => onChange((selected || []).map(option => option.value))}
            />
        </div>
    )
}

export default ShipmentTypesSelect
